module.exports = __webpack_public_path__ + "media/images/navbar/logo-rvb-8e168b31434f4e4b847db4b10c6d710b.png";